import { render, staticRenderFns } from "./FeedbackCard.vue?vue&type=template&id=3849ccdb&scoped=true"
import script from "./FeedbackCard.vue?vue&type=script&lang=js"
export * from "./FeedbackCard.vue?vue&type=script&lang=js"
import style0 from "./FeedbackCard.vue?vue&type=style&index=0&id=3849ccdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3849ccdb",
  null
  
)

export default component.exports